import { api } from '@/services';
import { ApiResponse } from '@/types';
import { isCurrentDay } from '@/utils';

import { IFaceIdProfileCreation } from '@/features/face-id-profiles/interfaces';
import { PROFILES_API_ENDPOINTS } from '@/constants/apiConfig.constants';
import { ProfileType } from '@/features/face-id-profiles/enums';

const FaceIdProfileCreationService = {
  CreateFaceIdProfile: async (
    profile: IFaceIdProfileCreation,
  ): Promise<ApiResponse<IFaceIdProfileCreation>> => {
    if (profile.profileType == ProfileType.Guest) {
      if (isCurrentDay(profile.guestValidFrom)) {
        profile.guestValidFrom = new Date();
      }
    }
    const response = await api.post(PROFILES_API_ENDPOINTS.PROFILES, profile);
    return response.data;
  },
};

export default FaceIdProfileCreationService;
